<!--底部-->
<template>
    <div class="footer">
        Copyright©2020.足趣网络科技有限公司
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    .footer {
        padding: 0.5rem 1rem;
        position: fixed;
        bottom: 0;
        width: 100%;
        max-width: 500px;
        box-sizing: border-box;
        background: linear-gradient(270deg, rgba(118, 75, 248, 1) 0%, rgba(187, 58, 246, 1) 100%);
        text-align: center;
        color: #FFF;
        line-height: 1.5rem;
    }
</style>
